import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createOperationWindowRule } from '@api/operationWindowRules';

import { TOperationWindowRuleDTO } from '@interfaces/cmModule/dto/operationWindowRulesDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { OPERATION_WINDOW_RULES, OPERATION_WINDOW_RULES_CREATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseQueryOperationWindowRulesCreateReturned {
	isLoadingCreateOperationWindowRule: boolean;
	createOperationWindowRule: UseMutateFunction<any, any, TOperationWindowRuleDTO, any>;
}

const useMutateOperationWindowRulesCreate = ({
	onSuccess,
}: Partial<IOnSuccess>): IUseQueryOperationWindowRulesCreateReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<TOperationWindowRuleDTO>({
		mutationKey: [OPERATION_WINDOW_RULES_CREATE],
		mutationFn: createOperationWindowRule,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.createOperationWindowRule,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([OPERATION_WINDOW_RULES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		createOperationWindowRule: mutateAsync,
		isLoadingCreateOperationWindowRule: isLoading,
	};
};

export default useMutateOperationWindowRulesCreate;
